<template>
  <user-list></user-list>
</template>

<script>

import UserList from './../../components/users/list'
export default {
  data: () => ({
  }),
  metaInfo() {
    return {
      title: this.$t('users.title')
    }
  },
  components: {
    UserList
  }
}
</script>